import React from 'react'
import SkuButtonOld from './SkuButtonOld'
import SkuPaymentButton from './SkuPaymentButton'

const SkuButton = (props) => {
  const { paymentIntegration } = props
  return !paymentIntegration ? (
    <SkuButtonOld {...props} />
  ) : (
    <SkuPaymentButton {...props} />
  )
}

export default SkuButton
